export var VALID_AMERICAN_DATE_FORMAT_REGULAR_EXPESSION = '^(1[0-2]|0[1-9])\\/(3[01]|[12][0-9]|0[1-9])\\/(000[1-9]|00[1-9][0-9]|0[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])$';
export var DATE_SHORT_YEAR = 'MM/DD/YY';